import { navigate } from "gatsby";
import styled from "styled-components";

export const ArticleCard = ({ hit }: {hit: any}) => {
    const Wrapper = styled.div`
  position: relative;
`;

const ImageContainer = styled.div`
  width: 100%;
  aspect-ratio: 1;
  position: relative;
  overflow: hidden;
  cursor: pointer;
`;

const StyledImage = styled.img`
  width: 100%;  /* Ensure the image takes full width of the div */
  height: 100%; /* Ensure the image takes full height of the div */
  object-fit: cover;  /* This ensures the image will cover the div without distortion */
  object-position: center;  /* This centers the image, useful for cropping */
`;

const Title = styled.div`
  line-height: 1.2;
  height: calc(1.2em * 2);
  margin-top: 12px;
  margin-bottom: 8px;
  overflow-y: hidden;
  font-size: 18px;
  cursor: pointer;
  font-weight: 600;
  color: black;
  &:hover {
    text-decoration: underline;
  }
`;

const Excerpt = styled.div`
  position: relative;
  line-height: 1.5;
  height: calc(1.5em * 4);
  overflow: hidden;
  margin-bottom: 40px;
  font-size: 15px;
`;

const Overlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px;
  background: linear-gradient(0deg, #fff 0%, hsla(0, 0%, 100%, 0));
`;

const ReadMore = styled.div`
  position:absolute;
  bottom:12px;
  color: black;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    text-decoration: underline;  /* Underline text on hover */
  }
`;
    return <Wrapper>
    <ImageContainer onClick={() => navigate(hit.slug + '/')}>
      <StyledImage
        src={hit.imageUrl + "?fm=webp&q=15"}
        alt="Thumbnail"
      />
    </ImageContainer>
    <Title onClick={() => navigate(hit.slug + '/')}>{hit.title}</Title>
    <Excerpt>
      <Overlay />
      {hit.description}
    </Excerpt>
    <ReadMore onClick={() => navigate(hit.slug + '/')}>Keep reading</ReadMore>
  </Wrapper>
}